import axios from 'axios';
import { CATEGORY_LIST } from '../paths';

export const getCategoryList = async () => {
  const response = await axios.get(CATEGORY_LIST);
  const results = response.data;
  return results;
};
